import { useQuery } from '@tanstack/react-query';
import apiService from '../../services/apiService';

export interface MaintenanceStatus {
  isEnabled: boolean;
  message?: string;
  estimatedEndTime?: string | null;
  allowAdminAccess?: boolean;
}

/**
 * Polls the public maintenance endpoint so the app can flip into
 * maintenance mode without a redeploy.
 *
 * Strategy:
 *   - Refetch every 60s
 *   - 30s stale time so most navigations reuse the cache without flicker
 *   - Continue polling in the background even when window is unfocused
 *     (so the moment maintenance ends, users come back online)
 *   - apiService swallows network errors and returns { isEnabled:false }
 *     so an outage in the settings endpoint doesn't lock everyone out.
 */
export function useMaintenance() {
  return useQuery<MaintenanceStatus>({
    queryKey: ['app-settings', 'maintenance'],
    queryFn: () => apiService.checkMaintenance(),
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
    refetchIntervalInBackground: true,
    retry: 1,
  });
}
